import { CURRENCIES } from "../../../Extension/Constants";
import { Currency } from "../../../Extension/src/Types/ExtensionTypes.ts";

export const shorten_key = (public_key: string, length: number = 4) => {
    if (length >= public_key.length / 2) {
        return public_key;
    } else {
        return public_key.slice(0, length) + "..." + public_key.slice(-length);
    }
};

export function truncate_text(text: string, maxChars: number) {
    return text.length > maxChars ? text.slice(0, maxChars) + "..." : text;
}

export function parseAdditionalMetadata(metadata: (readonly [string, string])[]): Record<string, string> {
    return metadata.reduce(
        (acc, [key, value]) => {
            acc[key] = value;
            return acc;
        },
        {} as Record<string, string>
    );
}

export const validateImageUrl = (url: string) => {
    return new Promise<boolean>((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(true); // Image loaded successfully
        img.onerror = () => resolve(false); // Image failed to load
    });
};

export function returnLocalNumber(currency: Currency, number: number) {
    return new Intl.NumberFormat(CURRENCIES[currency].locale, {
        style: "decimal",
    }).format(number);
}

// TODO: DO NOT LET ANY FREAKY NUMBER FORMATTING LOCALE TO BE USED. ONLY en-US and en-RU
export function returnLocalCurrencyString(currency: Currency, price: number) {
    return new Intl.NumberFormat(CURRENCIES[currency].locale, {
        style: "currency",
        currency: CURRENCIES[currency].currency,
    }).format(price);
}
